import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext();

export const useNotification = () => {
    return useContext(NotificationContext);
};

export const NotificationProvider = ({ children }) => {
    const [notification, setNotification] = useState({
        show: false,
        title: '',
        message: '',
        type: 'error', // 'error', 'success', 'warning'
        onConfirm: null,
        confirmButtonText: 'OK'
    });

    const showNotification = ({ title, message, type = 'error', onConfirm = null, confirmButtonText = 'OK' }) => {
        setNotification({
            show: true,
            title,
            message,
            type,
            onConfirm,
            confirmButtonText
        });
    };

    const hideNotification = () => {
        setNotification(prev => ({ ...prev, show: false }));
    };

    const showSubscriptionNotification = () => {
        const userEmail = localStorage.getItem('email') || "";
        const whatsappNumber = "923343725182";
        const text = `Hi I’d like to extend my free trial on FictionGenie.\nMy email: ${userEmail}`;
        const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;

        showNotification({
            title: 'Locked Story',
            message: (
                <div style={{ textAlign: 'left', padding: '0 10px' }}>
                    <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem', lineHeight: '1.5' }}>
                        You’re currently on the <strong style={{ color: '#ffc107' }}>free plan</strong>,
                        which allows you to read <strong style={{ color: '#ffc107' }}>7 stories</strong>.
                    </p>
                    <p style={{ fontSize: '1rem', lineHeight: '1.5', opacity: '0.9' }}>
                        If you’d like to continue reading more stories for <strong style={{ color: '#ffc107' }}>Free</strong>,
                        simply click the button below and we’ll help you from there 💛
                    </p>
                </div>
            ),
            confirmButtonText: "Extend my Subscription!",
            onConfirm: () => {
                window.open(whatsappUrl, '_blank');
            }
        });
    };

    return (
        <NotificationContext.Provider value={{ showNotification, hideNotification, notification, showSubscriptionNotification }}>
            {children}
        </NotificationContext.Provider>
    );
};
